module.exports = __webpack_public_path__ + "static/media/VISAFONDOBLANCO.pictogram.8f21abac.svg";